import React from "react";
import { connect } from "react-redux";
import { Container, Box, Typography } from "@material-ui/core";
import Loader from "../../../organisms/loader/Loader";
import { Alert } from "@material-ui/lab";
import { API_ROOT } from "../../../../baseUrls";
import AvatarWaitTimer from "../../../organisms/loader/AvatarWaitTimer";

class TalkTeach extends React.Component {
  state = {
    sessionState: "establishing",
  }

  getSessionEstablishmentUrl() {
    let url = API_ROOT+"/ai/lifenaut";
    let separator = "?";
    if (this.props.mindfile.bot_unique) {
      url += `${separator}unique=${encodeURIComponent(this.props.mindfile.bot_unique)}`;
      separator = "&";
    }
    if (this.props.mindfile.bot_security) {
      url += `${separator}security=${encodeURIComponent(this.props.mindfile.bot_security)}`;
    }
    return url;
  }

  tryToEstablishSession() {
    if (!this.props.mindfile || !this.props.mindfile.id || !this.props.avatarReady) {
      return;
    }

    this.setState({ sessionState: "establishing" });
    fetch(this.getSessionEstablishmentUrl())
      .then(resp => this.setState({ sessionState: resp.ok ? "established" : "failed" }))
      .catch(() => this.setState({ sessionState: "failed" }))
  }

  componentDidMount() {
    this.tryToEstablishSession();
  }

  componentDidUpdate(prevProps) {
    if ((!(prevProps.mindfile && prevProps.mindfile.id) && this.props.mindfile && this.props.mindfile.id)
     || (!prevProps.avatarReady && this.props.avatarReady)) {
      this.tryToEstablishSession();
    }
  }

  renderChatbotIframe() {
    return (
      <iframe
        src={API_ROOT+"/ai/teach"}
        title="AI Teach" style={{ width: "100%", height: 600, boxSizing: "border-box" }}
      />
    );
  }

  render() {
    if (!this.props.mindfile || !this.props.mindfile.id) {
      return <Loader />;
    }

    if (!this.props.avatarReady) {
      return <AvatarWaitTimer />;
    }

    let chatbot = null;
    switch (this.state.sessionState) {
      case "establishing":
        chatbot = <Loader text="Establishing a chatbot session..." />;
        break;
      case "established":
        chatbot = this.renderChatbotIframe();
        break;
      case "failed":
      default:
        chatbot = (
          <React.Fragment>
            <Alert severity="error">A connection the the chatbot could not be properly established.</Alert>
            {this.renderChatbotIframe()}
          </React.Fragment>
        );
        break;
    }

    return (
      <Container>
        <Box mt={5}>
          <Typography variant="h4">Talk and Teach</Typography>
          <Box mt={3}>{chatbot}</Box>
        </Box>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    avatarReady: !state.avatarReadyAt,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TalkTeach);
